import { render, staticRenderFns } from "./BulkPromotions.vue?vue&type=template&id=2ece4c54&scoped=true&"
import script from "./BulkPromotions.vue?vue&type=script&lang=js&"
export * from "./BulkPromotions.vue?vue&type=script&lang=js&"
import style0 from "./BulkPromotions.vue?vue&type=style&index=0&id=2ece4c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece4c54",
  null
  
)

export default component.exports